/**
 * PublicRoute.tsx — wrap pages that only make sense when NOT signed in.
 *
 * If a logged-in user revisits /login we send them straight to the
 * dashboard instead of showing the form again.
 */

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '../redux/hooks';
import { selectIsAuthed } from '../redux/slices/auth';

export default function PublicRoute() {
	const authed = useAppSelector(selectIsAuthed);
	const location = useLocation();
	if (authed) {
		const to = (location.state as { from?: string } | null)?.from || '/';
		return <Navigate to={to} replace />;
	}
	return <Outlet />;
}
